<div class="ab-container d-flex align-items-center" *ngIf="isBrowser">
    <div class="container">
        <div class="row r">
            <div class="col-12 text-center">
                <span class="number-notfound">404</span>
                <p class="mb-lg-4 mb-md-3 page-text">The page you are looking for is not found</p>
                <a class="back-to-home" routerlink="" href="/" title="Back to Home">Back to Home</a>
            </div>
        </div>
    </div>
</div>